import StarRatingContainer from "./Containers/StarRatingContainer";
export default StarRatingContainer;
